<template>
  <v-row class="pt-5" v-if="doc">
    <v-col cols="10" offset="1">
      <v-row>
        <v-col cols="4">
          <p class="blue--text headline">Stop</p>
          <ul class="list--none">
            <li class="ma-1" v-for="(tag, index) in doc.stop" :key="index">
              <span class="pr-2">{{ tag.title }}</span>
            </li>
          </ul>
        </v-col>
        <v-col cols="4">
          <p class="green--text headline mt-10">Keep</p>
          <ul class="list--none">
            <li class="ma-1" v-for="(tag, index) in doc.keep" :key="index">
              <span class="pr-2">{{ tag.title }}</span>
            </li>
          </ul>
        </v-col>
        <v-col cols="4">
          <p class="deep-orange--text headline mt-10">Start</p>
          <ul class="list--none">
            <li class="ma-1" v-for="(tag, index) in doc.start" :key="index">
              <span class="pr-2">{{ tag.title }}</span>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsTrafficUser",
  data() {
    return {
      doc: null,
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise() {
      this.doc = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.trafficExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", this.uid);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0].doc;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
